$(document).ready(function(){
	// console.log('KeyvisualSlider');

	if( $('.keyvisual-slider').length > 0 ){

		var directionalnav = false;
		if($('.keyvisual-slider').attr('data-directionalnav') == '1'){
			directionalnav = true;
			// console.log(directionalnav);
			$('.keyvisual-slider').flexslider({
				 	animation: "slide",
					animationLoop: false,
					slideshow: true,
					// controlNav: false,
					// directionNav: false,
					touch: true,
					controlsContainer: $(".keyslider-controls-container"),
            		customDirectionNav: $(".keyslider-navigation > a"),
            		start: function(slider) {
            			// BITV/WCAG: Fix ARIA roles if FlexSlider wraps buttons in ol/li
            			fixAriaRoles();
            			// Initialize button functionality
            			initializeTabControls(slider);
            		},
            		after: function(slider) {
            			// Update button states after slide change
            			updateTabStates(slider);
            		}
			});


		}else{
			 $('.keyvisual-slider').flexslider({
			 	animation: "slide",
				animationLoop: false,
				slideshow: true,
				controlNav: true,
				directionNav: false,
				touch: true,
				start: function(slider) {
					// BITV/WCAG: Fix ARIA roles if FlexSlider wraps buttons in ol/li
					fixAriaRoles();
					// Initialize button functionality
					initializeTabControls(slider);
				},
				after: function(slider) {
					// Update button states after slide change
					updateTabStates(slider);
				}
			 });
		}

		// BITV/WCAG: Use recommended ARIA tablist structure for slider bullets
		function fixAriaRoles() {
			// Check if FlexSlider created an ol element
			var $container = $('.keyslider-controls-container');
			var $ol = $container.find('ol, ul').first();
			var $slides = $('.keyvisual-slider .slides > li');
			
			if ($ol.length > 0) {
				// FlexSlider created ol/ul - use tablist structure for bullets
				$ol.attr('role', 'tablist').attr('aria-label', 'Bildauswahl');
				// Remove role from container div
				$container.removeAttr('role').removeAttr('aria-label');
				
				// Ensure all li elements have role="presentation"
				$ol.find('li').each(function(index) {
					var $li = $(this);
					$li.attr('role', 'presentation');
					
					// Add unique IDs to slides if not present
					var $slide = $slides.eq(index);
					if (!$slide.attr('id')) {
						$slide.attr('id', 'keyvisual-slide-' + index);
					}
					var slideId = $slide.attr('id');
					
					// Find the button/link inside and set it as a tab
					var $button = $li.find('button, a').first();
					if ($button.length > 0) {
						$button.attr('role', 'tab')
							   .attr('aria-controls', slideId)
							   .attr('id', 'keyvisual-tab-' + index);
						
						// Set initial state
						if ($button.hasClass('flex-active') || index === 0) {
							$button.attr('aria-selected', 'true').attr('tabindex', '0');
							$slide.attr('aria-labelledby', 'keyvisual-tab-' + index);
						} else {
							$button.attr('aria-selected', 'false').attr('tabindex', '-1');
						}
					}
				});
			} else {
				// No ol/ul created - use tablist directly on container
				$container.attr('role', 'tablist').attr('aria-label', 'Bildauswahl');
				
				// Set buttons as tabs
				$container.find('.flex-control-nav-item').each(function(index) {
					var $button = $(this);
					var $slide = $slides.eq(index);
					
					if (!$slide.attr('id')) {
						$slide.attr('id', 'keyvisual-slide-' + index);
					}
					var slideId = $slide.attr('id');
					
					$button.attr('role', 'tab')
						   .attr('aria-controls', slideId)
						   .attr('id', 'keyvisual-tab-' + index);
					
					if (index === 0) {
						$button.attr('aria-selected', 'true').attr('tabindex', '0');
						$slide.attr('aria-labelledby', 'keyvisual-tab-' + index);
					} else {
						$button.attr('aria-selected', 'false').attr('tabindex', '-1');
					}
				});
			}
		}

		// Initialize tab controls functionality with keyboard support
		function initializeTabControls(slider) {
			var $slides = $('.keyvisual-slider .slides > li');
			
			// Handle both direct buttons and buttons inside ol/li structure
			$('.keyslider-controls-container .flex-control-nav-item, .keyslider-controls-container ol li button, .keyslider-controls-container ul li button').each(function(index) {
				var $tab = $(this);
				
				$tab.on('click', function(e) {
					e.preventDefault();
					slider.flexAnimate(index);
					$tab.focus();
				});
				
				$tab.on('keydown', function(e) {
					var currentIndex = slider.currentSlide;
					var totalSlides = slider.count;
					var $allTabs = $('.keyslider-controls-container [role="tab"]');
					
					switch(e.key) {
						case 'ArrowRight':
						case 'ArrowDown':
							e.preventDefault();
							var nextIndex = (currentIndex + 1) % totalSlides;
							slider.flexAnimate(nextIndex);
							$allTabs.eq(nextIndex).focus();
							break;
						case 'ArrowLeft':
						case 'ArrowUp':
							e.preventDefault();
							var prevIndex = (currentIndex - 1 + totalSlides) % totalSlides;
							slider.flexAnimate(prevIndex);
							$allTabs.eq(prevIndex).focus();
							break;
						case 'Home':
							e.preventDefault();
							slider.flexAnimate(0);
							$allTabs.eq(0).focus();
							break;
						case 'End':
							e.preventDefault();
							slider.flexAnimate(totalSlides - 1);
							$allTabs.eq(totalSlides - 1).focus();
							break;
					}
				});
			});
		}
		
		// Update tab states using ARIA tablist pattern
		function updateTabStates(slider) {
			var $slides = $('.keyvisual-slider .slides > li');
			
			// Handle both direct buttons and buttons inside ol/li structure
			$('.keyslider-controls-container .flex-control-nav-item, .keyslider-controls-container ol li button, .keyslider-controls-container ul li button').each(function(index) {
				var $tab = $(this);
				var $slide = $slides.eq(index);
				
				if (index === slider.currentSlide) {
					// Active tab
					$tab.attr('aria-selected', 'true').attr('tabindex', '0');
					// Link slide to active tab
					if ($tab.attr('id')) {
						$slide.attr('aria-labelledby', $tab.attr('id'));
					}
				} else {
					// Inactive tabs
					$tab.attr('aria-selected', 'false').attr('tabindex', '-1');
				}
			});
		}

	}
});